import React, { CSSProperties } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

interface LazyImageProps {
  src: string;
  srcSet?: string;
  sizes?: string;
  alt: string;
  placeholderSrc?: string;
  fallbackSrc?: string;
  effect?: "blur" | "opacity" | "black-and-white";
  threshold?: number;
  sx?: CSSProperties;
  className?: string;
  width?: string | number;
  height?: string | number;
  onLoad?: React.ReactEventHandler<HTMLImageElement>;
  onError?: React.ReactEventHandler<HTMLImageElement>;
  wrapperClassName?: string;
  wrapperProps?: Record<string, unknown>;
}

const LazyImage = ({
  src,
  srcSet,
  sizes,
  alt,
  placeholderSrc,
  fallbackSrc = "",
  effect = "blur",
  threshold = 100,
  sx = {},
  className = "",
  width,
  height,
  onLoad,
  onError,
  wrapperClassName,
  wrapperProps = {},
  ...rest
}: LazyImageProps) => {
  return (
    <LazyLoadImage
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      effect={effect}
      threshold={threshold}
      placeholderSrc={placeholderSrc}
      width={width}
      height={height}
      style={sx}
      className={className}
      wrapperClassName={wrapperClassName}
      wrapperProps={wrapperProps}
      onLoad={onLoad}
      onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
        if (fallbackSrc && e.currentTarget) {
          e.currentTarget.src = fallbackSrc;
        }
        if (onError) {
          onError(e);
        }
      }}
      delayTime={0}
      useIntersectionObserver={true}
      {...rest}
    />
  );
};

export default LazyImage;
